/**
 * Date formatting utilities — every user-facing timestamp in the app is
 * rendered as New Zealand local time (Pacific/Auckland, NZST/NZDT).
 *
 * Why force the zone instead of using browser-local?
 *   - Raisey's is a New Zealand business. Their staff (and audit log readers)
 *     expect every timestamp to read in NZ time, even if the admin is signed
 *     in while travelling overseas.
 *   - Backend stores everything as UTC ISO strings; we let the browser do the
 *     conversion to NZ here so storage stays unambiguous.
 *
 * Pass any ISO 8601 string (or Date / number). Returns '—' for null/undefined/invalid.
 */
const NZ_ZONE = 'Pacific/Auckland';
const NZ_LOCALE = 'en-NZ';

const _parse = (input) => {
  if (input === null || input === undefined || input === '') return null;
  const d = input instanceof Date ? input : new Date(input);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** Long form: "24 Feb 2026, 3:42 pm". */
export const formatNzDateTime = (input, opts = {}) => {
  const d = _parse(input);
  if (!d) return '—';
  return new Intl.DateTimeFormat(NZ_LOCALE, {
    timeZone: NZ_ZONE,
    day: '2-digit', month: 'short', year: 'numeric',
    hour: 'numeric', minute: '2-digit',
    ...opts,
  }).format(d);
};

/** Short form: "24/02/2026". */
export const formatNzDate = (input, opts = {}) => {
  const d = _parse(input);
  if (!d) return '—';
  return new Intl.DateTimeFormat(NZ_LOCALE, {
    timeZone: NZ_ZONE,
    day: '2-digit', month: '2-digit', year: 'numeric',
    ...opts,
  }).format(d);
};
